import { INationalParkAdvisoryProperties } from '@autopylot-internal/tiles-client';
import { SecondaryWarningAdvisory } from '../SecondaryAdvisory.tsx';
import { AdvisoryBlockIcon } from '../../components/icons/Icons.tsx';
import { ICompositeAdvisoryProperties } from './ICompositeAdvisoryProperties.ts';
import { AdvisoryLink } from './AdvisoryLink.tsx';

export const NationalParkAdvisory = (props: ICompositeAdvisoryProperties<INationalParkAdvisoryProperties>) => {
    const distinctNames = Array.from(new Set(props.advisories.map(a => a.UNIT_NAME)));
    return (
        <SecondaryWarningAdvisory header="National Park Service" advisoryType={props.advisoryType} GLOBAL_ID={props.advisories[0].GLOBAL_ID} iconColor='danger' icon={AdvisoryBlockIcon}>
            <>
                <p>
                    Your mission overlaps <strong>{distinctNames.join(', ')}</strong>. Check with the National Park Service prior to flight.
                </p>
                <p>
                    Prior to flight, the remote pilot in command must assess the local airspace along with any other takeoff, landing, and flight restrictions.
                </p>
                <p>
                    <AdvisoryLink
                        text="Drones and National Parks"
                        url="https://www.nps.gov/articles/uncrewed-aircraft-in-the-national-parks.htm"
                    />
                </p>
            </>
        </SecondaryWarningAdvisory>
    );
};
